(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const menuItems = document.querySelectorAll('.header__menu-item');
    const overlay = document.getElementById('subnav-overlay');
    let hideTimeout;
    let activeSubnav = null;

    if (!overlay) return;

    function hideAllSubnavs() {
      document.querySelectorAll('.subnav-container').forEach((nav) => {
        nav.classList.add('subnav--hidden');
        nav.classList.remove('subnav--visible');
      });
      overlay.classList.add('overlay--hidden');
      activeSubnav = null;
    }

    function hideSubnav(subnav) {
      if (activeSubnav === subnav) {
        hideAllSubnavs();
      }
    }

    function showSubnav(subnav) {
      clearTimeout(hideTimeout);
      if (activeSubnav !== subnav) {
        hideAllSubnavs();
      }
      subnav.classList.remove('subnav--hidden');
      subnav.classList.add('subnav--visible');
      overlay.classList.remove('overlay--hidden');
      activeSubnav = subnav;

      // Close search bar when subnav opens
      const liveSearch = document.querySelector('[data-live-search]');
      const searchOverlay = document.getElementById('search-bar-overlay');
      if (liveSearch) {
        liveSearch.classList.add('live-search--hidden');
      }
      if (searchOverlay) {
        searchOverlay.classList.add('overlay--hidden');
      }
    }

    menuItems.forEach((item) => {
      const collection = item.dataset.collection;
      const subnav = document.querySelector(`.subnav-container[data-collection="${collection}"]`);

      if (!subnav) return;

      item.addEventListener('mouseenter', () => {
        showSubnav(subnav);
      });

      item.addEventListener('mouseleave', () => {
        hideTimeout = setTimeout(() => {
          hideSubnav(subnav);
        }, 200);
      });

      subnav.addEventListener('mouseenter', () => {
        showSubnav(subnav);
      });

      subnav.addEventListener('mouseleave', () => {
        hideTimeout = setTimeout(() => {
          hideSubnav(subnav);
        }, 200);
      });
    });

    overlay.addEventListener('click', (e) => {
      e.stopPropagation();
      hideAllSubnavs();
    });

    // Mobile menu
    const hamburgerBtn = document.getElementById('hamburger-btn');
    const mobileMenuClose = document.getElementById('mobile-menu-close');
    const mobileMenu = document.getElementById('mobile-menu');
    const header = document.getElementById('header');
    const announcementBar = document.getElementById('announcement-bar');

    // Calculate and set header height (including announcement bar)
    function updateHeaderHeight() {
      let totalHeight = 0;

      if (header) {
        totalHeight += header.offsetHeight;
      }

      if (announcementBar) {
        totalHeight += announcementBar.offsetHeight;
      }

      document.documentElement.style.setProperty('--header-height', `${totalHeight}px`);
    }

    // Set initial header height and update on resize
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);

    if (hamburgerBtn && mobileMenu) {
      hamburgerBtn.addEventListener('click', () => {
        mobileMenu.classList.add('mobile-menu--open');
        hamburgerBtn.classList.add('menu-hidden');
        mobileMenuClose.classList.add('menu-visible');
        window.lockOverflow?.('mobile-menu');
      });

      mobileMenuClose.addEventListener('click', () => {
        mobileMenu.classList.remove('mobile-menu--open');
        hamburgerBtn.classList.remove('menu-hidden');
        mobileMenuClose.classList.remove('menu-visible');
        window.unlockOverflow?.('mobile-menu');
      });
    }

    // Close mobile menu when search is opened
    const headerSearch = document.querySelector('.header__search');
    if (headerSearch && mobileMenu) {
      headerSearch.addEventListener('click', () => {
        if (mobileMenu.classList.contains('mobile-menu--open')) {
          mobileMenu.classList.remove('mobile-menu--open');
          window.unlockOverflow?.('mobile-menu');
          hamburgerBtn.classList.remove('menu-hidden');
          mobileMenuClose.classList.remove('menu-visible');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const thumbnails = document.querySelectorAll('.thumbnail');
    const track = document.querySelector('.slider-track');
    const slides = document.querySelectorAll('.slide');
    const slider = document.querySelector('.vertical-slider');

    let activeIndex = 0;
    let startY = 0;
    let currentY = 0;
    let isDragging = false;

    function goToSlide(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));

      const slideHeight = slides[0].offsetHeight;
      track.style.transform = `translateY(-${index * slideHeight}px)`;

      thumbnails.forEach((t) => t.classList.remove('active'));
      thumbnails[index].classList.add('active');

      activeIndex = index;
    }

    /* -----------------------
      Thumbnail Click
    ----------------------- */
    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', () => goToSlide(index));
    });

    /* -----------------------
      Touch Swipe
    ----------------------- */
    slider.addEventListener('touchstart', (e) => {
      startY = e.touches[0].clientY;
      isDragging = true;
    });

    slider.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      currentY = e.touches[0].clientY;
    });

    slider.addEventListener('touchend', () => {
      if (!isDragging) return;

      const diff = startY - currentY;

      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          goToSlide(activeIndex + 1); // swipe up
        } else {
          goToSlide(activeIndex - 1); // swipe down
        }
      }

      isDragging = false;
    });

    /* -----------------------
      Keyboard Support
    ----------------------- */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        goToSlide(activeIndex + 1);
      }

      if (e.key === 'ArrowUp') {
        e.preventDefault();
        goToSlide(activeIndex - 1);
      }
    });

    /* -----------------------
      Resize Fix
    ----------------------- */
    window.addEventListener('resize', () => {
      goToSlide(activeIndex);
    });

    /* -----------------------
      AddToCart Overlay Control (Scroll-based)
    ----------------------- */
    const addToCartButton = document.querySelector('.product-form-container');
    const addToCartOverlay = document.getElementById('addToCartOverlay');
    const footer = document.querySelector('footer');

    if (addToCartButton && addToCartOverlay) {
      const handleScroll = () => {
        const buttonRect = addToCartButton.getBoundingClientRect();
        const isButtonVisible = buttonRect.bottom > 0 && buttonRect.top < window.innerHeight;

        // Check if footer is visible
        let isFooterVisible = false;
        if (footer) {
          const footerRect = footer.getBoundingClientRect();
          isFooterVisible = footerRect.top < window.innerHeight;
        }

        if (isButtonVisible || isFooterVisible) {
          // Add to cart button or footer is in viewport, hide overlay
          addToCartOverlay.classList.remove('active');
        } else {
          // Add to cart button and footer are out of viewport, show overlay
          addToCartOverlay.classList.add('active');
        }
      };

      window.addEventListener('scroll', handleScroll);
      // Check initial state
      handleScroll();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
